<script setup lang="ts">
import type { CartItem } from "@/schemas/cart";

defineProps<{ cartItem: CartItem }>();
</script>

<template>
  <div class="text-2xl font-semibold text-primary">
    {{ currency(cartItem.subtotal) }}
  </div>
</template>
